import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { portfolioRouteDefinitions } from './PortfolioRouteDefinitions';

import { generatePageWithTabsRoute } from '../routeGenerator';

const PortfolioRoutes: RouteObject = generatePageWithTabsRoute(
  'Overview of data and diagnostics across your portfolio',
  BASE.INTERVAL_DATA_PORTFOLIO,
  NESTED_ROUTES.INTERVAL_DATA_PORTFOLIO.SITES,
  portfolioRouteDefinitions,
);

export default PortfolioRoutes;
